<template>
  <p class="product-delivery-sale">
    {{ messages?.discountsInternationalDelivery }}
    <svg class="product-delivery-sale__icon">
      <use xlink:href="#svg-question"></use>
    </svg>
  </p>
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { computed } from 'vue';

const { state } = useStore();

const messages = computed(() => state.product.data.messages);
</script>

<style lang="scss" scoped>
.product-delivery-sale {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(235, 224, 245, 0.4);
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  padding: 8px 12px;
  margin-bottom: 8px;
  &__icon {
    fill: currentColor;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }
}
</style>
